import { load } from '@/router/routes/index';

export default [
    {
        path: 'statistics',
        name: 'statistic.index',
        component: load('statistic/StatisticIndex'),
        meta: { auth: true },
    },
];
